// src/shared/hooks/useUserTheme.ts
import { useUser } from "src/shared/context/UserContext";
import { colorOptions, fontOptions, borderHighlightOptions, SidebarThemeClass } from "src/shared/modules/profile/theme/themeConstants";

export const useUserTheme = () => {
  const { user } = useUser();

  const themeKey = user?.themes.backgroundColour || "DodgerBlue";
  const bgClass = colorOptions[themeKey];
  const fontClass = fontOptions[user?.themes.fontFamily || "Sans-serif"];
  const borderHighlight = borderHighlightOptions[themeKey] || "focus:ring-blue-500";
  const sidebarThemeClass = SidebarThemeClass[themeKey] || SidebarThemeClass["DodgerBlue"];

  return { themeKey, bgClass, fontClass, borderHighlight, colorClass: colorOptions[themeKey] || "", sidebarThemeClass };
};
